import { Study } from '@models';

export interface ColumnConfig {
  displayName: string;
  hasCustomContent: boolean;
  hasHeaderMenu: boolean;
  isSticky: boolean;
}

export const columnConfigurations: Partial<Record<keyof Study, ColumnConfig>> = {
  clientName: {
    displayName: 'Sponsor/Client',
    hasCustomContent: false,
    hasHeaderMenu: false,
    isSticky: true
  },
  protocolNumber: {
    displayName: 'Protocol number',
    hasCustomContent: true,
    hasHeaderMenu: false,
    isSticky: true
  },
  studyStage: {
    displayName: 'Stage',
    hasCustomContent: false,
    hasHeaderMenu: true,
    isSticky: false
  },
  sitesActivated: {
    displayName: 'Sites activated',
    hasCustomContent: false,
    hasHeaderMenu: false,
    isSticky: false
  },
  subjectsEnrolled: {
    displayName: 'Subjects enrolled',
    hasCustomContent: false,
    hasHeaderMenu: false,
    isSticky: false
  },
  nextMilestone: {
    displayName: 'Next milestone',
    hasCustomContent: false,
    hasHeaderMenu: true,
    isSticky: false
  },
  milestoneStatus: {
    displayName: 'Milestone status',
    hasCustomContent: true,
    hasHeaderMenu: true,
    isSticky: false
  },
  studyPhase: {
    displayName: 'Phase',
    hasCustomContent: false,
    hasHeaderMenu: true,
    isSticky: false
  },
  therapeuticArea: {
    displayName: 'Therapeutic area',
    hasCustomContent: false,
    hasHeaderMenu: true,
    isSticky: false
  },
  indication: {
    displayName: 'Indication',
    hasCustomContent: false,
    hasHeaderMenu: true,
    isSticky: false
  },
  drugName: {
    displayName: 'Drug/asset',
    hasCustomContent: false,
    hasHeaderMenu: true,
    isSticky: false
  },
  studyStatus: {
    displayName: 'Status',
    hasCustomContent: false,
    hasHeaderMenu: true,
    isSticky: false
  },
  accelerator: {
    displayName: 'Accelerator',
    hasCustomContent: false,
    hasHeaderMenu: true,
    isSticky: false
  },
  fspIndicator: {
    displayName: 'FSP Study',
    hasCustomContent: false,
    hasHeaderMenu: true,
    isSticky: false
  },
  country: {
    displayName: 'Country',
    hasCustomContent: true,
    hasHeaderMenu: false,
    isSticky: false
  }
  // region: {
  //   displayName: 'Region',
  //   hasCustomContent: true,
  //   hasHeaderMenu: false,
  //   isSticky: false
  // },
  // studyHealthScore: {
  //   displayName: 'Study health score',
  //   hasCustomContent: false,
  //   hasHeaderMenu: true,
  //   isSticky: false
  // },
  // spendToBudgetScore: {
  //   displayName: 'Spend-to-budget score',
  //   hasCustomContent: false,
  //   hasHeaderMenu: true,
  //   isSticky: false
  // },
};
